// extracted by mini-css-extract-plugin
export default {"EledoLoader":"EledoLoader_EledoLoader__x5zWm","scaling":"EledoLoader_scaling__NP6-z"};